import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import SwalServices from '../../../services/swalServices/SwalServices';
import CommonServices from '../../../services/axioServices/apiServices/CommonServices';
import ItemMasterServices from '../../../services/axioServices/apiServices/ItemMasterServices';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import QCServices from '../../../services/axioServices/apiServices/QCServices';
import RawMaterialSampleEntryInputs from './RawMaterialSampleEntryInputs';
import { Navigate } from 'react-router-dom';
import MaterialListModelForQc from './MaterialListModelForQc';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import moment from 'moment/moment';
import { decryptAES } from '../../../utils/Encryption';

export default class PackingMaterialSampleEntryDetails extends Component {
    constructor(props) {
        super(props);
        this.qcServices = new QCServices();
        this.itemMasterServices = new ItemMasterServices();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.state = {
            materialList: [],
            supplierList: [],
            labList: [],
            setGrnMaterialDetailspopUp: false,
            sampleEntryPMId: null,
            route: null,
            sampleObject: {
                refNo: "",
                refDate: "",
                grnNo: "",
                receivedDate: "",
                materialId: "",
                standard: "",
                batchNo: "",
                invoiceNo: "",
                invoiceDate: "",
                sampleQty: "",
                purchaseQty: "",
                mfgDate: "",
                expDate: "",
                supplierId: "",
                mfgBy: "",
                grnId: "",
                uom: "",
                conditionOfContainer: "",
                noOfContainer: "",
                labName: "",
                isOutSideAnalysis: 0,
                remark: ""
            },
            isTestReportEntry: false,
            tableData: [],
            columns: [
                { field: 'grnNo', header: 'Grn. No', width: '12%' },
                { field: 'grnDate', header: 'Grn. Date', width: '15%' },
                { field: 'invoiceNo', header: 'Invoice No', width: '15%' },
                { field: 'materialName', header: 'Material Name', width: '28%' },
                { field: 'materialBatchNo', header: 'Batch No', width: '20%' },
                { field: 'materialQty', header: 'Quantity', width: '20%' },
                { field: 'action', header: 'Action', body: this.actionTemplate, sortable: false, width: '10%' }
            ],
            validationRules: {
                materialId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "material name"
                        ),
                    },
                ],
                supplierId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "supplier name"
                        ),
                    },
                ],
                grnNo: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "grn no"
                        ),
                    },
                ],
                sampleQty: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "sample qty"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let sampleEntryPMId = decryptAES(id)
            if (sampleEntryPMId) {
                if (sampleEntryPMId != null) {
                    this.setState({ sampleEntryPMId: sampleEntryPMId }, () => {
                        this.getPackingMaterialSampleEntryDetailsById(this.state.sampleEntryPMId)
                    });
                }
            }
        } else {
            this.getPackingMaterialSampleEntryCount()
        }

        this.getAllPackingMaterialDropdown()
    }

    getPackingMaterialSampleEntryDetailsById = (sampleEntryPMId) => {
        this.qcServices.getPackingMaterialSampleEntryDetailsById(sampleEntryPMId).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let details = this.state.sampleObject
                details.refNo = res.refNo
                details.refDate = res.refDate ? moment(res.refDate).format('YYYY-MM-DD') : ''
                details.grnNo = res.grnNo
                details.receivedDate = moment(res.receivedDate).format('YYYY-MM-DD')
                details.materialId = res.pmId
                details.standard = res.standard
                details.batchNo = res.batchNo
                details.invoiceNo = res.invoiceNo
                details.invoiceDate = res.invoiceDate ? moment(res.invoiceDate).format('YYYY-MM-DD') : ''
                details.sampleQty = res.sampleQty
                details.purchaseQty = res.purchaseQty
                details.mfgDate = res.mfgDate ? moment(res.mfgDate).format('YYYY-MM-DD') : ''
                details.expDate = res.expDate ? moment(res.expDate).format('YYYY-MM-DD') : ''
                details.supplierId = res.supplierId
                details.mfgBy = res.mfgBy
                details.conditionOfContainer = res.conditionOfContainer
                details.noOfContainer = res.noOfContainer
                details.labName = res.labName
                details.isOutSideAnalysis = res.isOutSideAnalysis === true ? 1 : 0
                details.grnId = res.grnId
                details.uom = res.uom
                details.remark = res.remark
                this.setState({ sampleObject: details, isTestReportEntry: res.isTestReportEntry })

            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getAllPackingMaterialDropdown = () => {
        this.commonServices.getAllPackingMaterialDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.pmName,
                    value: item._id,
                }));
                this.setState({ materialList: dropdownItems }, () => {
                    this.getAllPartyDropdown()
                });
            } else {
                this.SwalServices.Error(response.Message);
                this.getAllPartyDropdown()
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                }));
                this.setState({ supplierList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getPackingMaterialSampleEntryCount = () => {
        this.qcServices.getPackingMaterialSampleEntryCount().then((response) => {
            if (response.statusCode == 200 && response.responseData !== null) {
                let sampleObject = this.state.sampleObject
                sampleObject.refNo = response.responseData.refNo
                sampleObject.refDate = moment(new Date()).format('YYYY-MM-DD')
                this.setState({ sampleObject: sampleObject })
            }
        });
    };

    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.sampleObject;
        details[name] = value.toUpperCase();
        this.setState({ sampleObject: details });
    };

    setFilterParametersForItemName = (selected, name) => {
        if (selected.value) {
            if (name === "materialId") {
                let sampleObject = this.state.sampleObject
                sampleObject.materialId = selected.value;
                sampleObject.standard = selected.standard;
                this.setState({ sampleObject: sampleObject });
            } else {
                let sampleObject = this.state.sampleObject;
                sampleObject[name] = selected.value;
                this.setState({ sampleObject: sampleObject });
            }
        }
    }

    handleToggle = (e) => {
        let checked = e.target.checked;
        this.setState({
            sampleObject: {
                ...this.state.sampleObject,
                isOutSideAnalysis: checked ? 1 : 0
            }
        });
    }

    getGRNItemsByGRNNo = () => {
        this.qcServices.getGRNItemsByGRNNo(['Packing']).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.setState({ tableData: response.responseData }, () => {
                    this.setState({ setGrnMaterialDetailspopUp: true })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    setOpenModel = () => {
        this.setState({ setGrnMaterialDetailspopUp: !this.state.setGrnMaterialDetailspopUp });
    };

    actionTemplate = (rowData) => {
        return (
            <div className="flex gap-2">
                <button
                    className="search-btn w-[28px] h-[28px] bg-blue text-white rounded"
                    onClick={() => this.handleSelectMaterial(rowData)}
                >
                    <FontAwesomeIcon icon={faArrowRight} className='w-[14px] h-[14px]' />
                </button>
            </div>
        );
    };

    handleSelectMaterial = (rowData) => {
        let details = this.state.sampleObject
        details.receivedDate = moment(rowData.grnDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        details.materialId = rowData.materialId
        details.batchNo = rowData.materialBatchNo
        details.invoiceNo = rowData.invoiceNo
        details.invoiceDate = moment(rowData.invoiceDate).format('YYYY-MM-DD')
        details.purchaseQty = rowData.materialQty
        details.mfgDate = rowData.mfgDate
            ? moment(rowData.mfgDate).format('YYYY-MM-DD')
            : null

        details.expDate = rowData.expDate
            ? moment(rowData.expDate).format('YYYY-MM-DD')
            : null
        details.supplierId = rowData.partyId
        details.mfgBy = rowData.materialMfgBy
        details.grnId = rowData._id
        details.uom = rowData.uom
        details.grnNo = rowData.grnNo
        this.setState({ sampleObject: details }, () => {
            this.setState({ setGrnMaterialDetailspopUp: false });
        })
    }

    isAllFieldsValidate = () => {
        const newValidState = isValidForm(
            this.state.sampleObject,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid
    }

    addEditPackingMaterialSampleEntry = () => {
        if (this.state.isTestReportEntry === false) {
            let isValid = this.isAllFieldsValidate()
            if (isValid) {
                let sampleObject = this.state.sampleObject
                let request = {
                    refNo: sampleObject.refNo,
                    refDate: sampleObject.refDate,
                    grnNo: sampleObject.grnNo,
                    receivedDate: sampleObject.receivedDate,
                    batchNo: sampleObject.batchNo,
                    invoiceNo: sampleObject.invoiceNo,
                    invoiceDate: sampleObject.invoiceDate !== 'Invalid date' ? sampleObject.invoiceDate : null,
                    sampleQty: sampleObject.sampleQty,
                    purchaseQty: sampleObject.purchaseQty,
                    mfgDate: sampleObject.mfgDate,
                    expDate: sampleObject.expDate,
                    conditionOfContainer: sampleObject.conditionOfContainer,
                    supplierId: sampleObject.supplierId,
                    noOfContainer: sampleObject.noOfContainer,
                    mfgBy: sampleObject.mfgBy,
                    isOutSideAnalysis: sampleObject.isOutSideAnalysis,
                    labName: sampleObject.labName,
                    grnId: sampleObject.grnId,
                    pmId: sampleObject.materialId,
                    remark: sampleObject.remark
                }
                if (this.state.sampleEntryPMId) {
                    request.sampleEntryPMId = this.state.sampleEntryPMId
                }
                this.qcServices.addEditPackingMaterialSampleEntry(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData !== null) {
                        if (this.state.sampleEntryPMId) {
                            this.navigate()
                        } else {
                            this.navigate()
                        }
                        this.SwalServices.Success(response.Message)
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                })
            }
        } else {
            this.SwalServices.Warning('Test report is already added for this sample. So, you can not edit the details.');
        }
    }

    generateSampleEntryPmReport = () => {
        this.setState({ isLoading: 'print' }, () => {
            let request = [this.state.sampleEntryPMId]
            this.qcServices.generateSampleEntryPmReport(request).then((response) => {
                if (response && response.status === 200) {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    // let blob = new Blob([response.data])
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.click();
                    this.setState({ isLoading: "" })
                }
                this.setState({ isLoading: false });
            })
        })
    }

    navigate = () => {
        this.setState({ route: '/PackingMaterialSampleEntry' })
    }

    render() {
        if (this.state.route !== null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='raw-sample-fields'>
                <h1 className='text-[20px] font-semibold text-blue pb-[5px] mb-[5px]'>Packing Material Sample Entry</h1>
                <RawMaterialSampleEntryInputs
                    sampleObject={this.state.sampleObject}
                    handleChange={this.handleChange}
                    handleToggle={this.handleToggle}
                    materialList={this.state.materialList}
                    supplierList={this.state.supplierList}
                    labList={this.state.labList}
                    getGRNItemsByGRNNo={this.getGRNItemsByGRNNo}
                    validState={this.state.validState}
                />
                <div className='btn-grp flex items-center gap-5 mt-2.5 pt-2.5 border-t border-gray-200'>
                    <button className='search-btn' onClick={this.addEditPackingMaterialSampleEntry}>
                        {this.state.sampleEntryPMId ? 'Save' : 'Add'}
                    </button>
                    <button className='cancel-btn'
                        onClick={this.navigate}
                    >
                        Cancel
                    </button>

                    {this.state.sampleEntryPMId !== null && this.state.sampleEntryPMId !== undefined && this.state.sampleEntryPMId !== "" ?
                        <button className='print-btn' onClick={this.generateSampleEntryPmReport}>Print</button>
                        : null}
                </div>
                <MaterialListModelForQc
                    tableData={this.state.tableData}
                    columns={this.state.columns}
                    setGrnMaterialDetailspopUp={this.state.setGrnMaterialDetailspopUp}
                    sampleObject={this.state.sampleObject}
                    setOpenModel={this.setOpenModel}
                />
            </div>
        )
    }
}
